// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__30bB-","choiceBoxes":"toolbarselects_choiceBoxes__1g61o","simpleField":"toolbarselects_simpleField__3upcC"};